<div class="min-h-screen flex items-center justify-center p-2 md:p-4">
  <ion-grid class="w-full max-w-md md:max-w-lg lg:max-w-xl">
    @if (!loading) {
      <div
        class="flex flex-col items-center justify-between min-h-[85dvh] md:min-h-[80dvh] py-4 md:py-6"
      >
        <!-- Logo y nombre de empresa -->
        <ion-row class="w-full flex justify-center pt-4 md:pt-6">
          <div class="flex flex-col items-center justify-center">
            <ion-img
              class="home-logo"
              [src]="LOGO_URL"
            ></ion-img>
            <!-- <span class="font-bold text-base md:text-lg lg:text-xl mt-2"
              >Nombre Empresa</span
            > -->
          </div>
        </ion-row>

        <ion-row
          class="w-full flex justify-center text-center px-2 md:px-4 py-4"
        >
          <ion-text>
            <h1
              class="font-bold text-2xl md:text-3xl lg:text-4xl w-full text-center"
            >
              ¡Bienvenido!
            </h1>
          </ion-text>
        </ion-row>

        <div class="w-full flex-1 flex flex-col justify-center">
          @if (showUrlError) {
            <ion-text class="text-center px-4 md:px-6 py-2">
              <p class="font-bold text-base md:text-lg">
                El link de firma no es válido o ya fue utilizado.
              </p>
              <p class="font-bold text-base md:text-lg mt-2 md:mt-3">
                Por favor, solicite un nuevo link.
              </p>
            </ion-text>
          } @else {
            <ion-row class="text-center px-4 md:px-6 py-2">
              @if (showFirmaDigitalHome || !firmaYOnboarding) {
                <div class="space-y-3 md:space-y-4">
                  <ion-text>
                    <p class="font-bold text-base md:text-lg">
                      ¡Tu contrato está listo!
                    </p>
                  </ion-text>
                  <ion-text>
                    <p class="font-bold text-base md:text-lg">
                      Por favor, revisa todo el documento y avanza hasta el
                      final para proceder con la firma.
                    </p>
                  </ion-text>
                </div>
              } @else {
                <div class="space-y-3 md:space-y-4">
                  <ion-text>
                    <p class="font-bold text-base md:text-lg">
                      Con solo tu número de documento podrás descubrir las
                      opciones de nuestros préstamos que mejor se adaptan a tus
                      necesidades.
                    </p>
                  </ion-text>
                  <ion-text>
                    <p class="font-bold text-base md:text-lg">
                      ¿Te gustaría saber qué préstamos podemos ofrecerte?
                    </p>
                  </ion-text>
                </div>
              }
            </ion-row>
          }
        </div>

        <!-- Botón de acción -->
        <ion-row class="w-full flex justify-center px-4 py-4 md:py-6">
          <section class="w-full flex justify-center">
            <ion-button
              (click)="navigateToNextStep()"
              expand="block"
              class="min-h-12 md:min-h-14 w-full max-w-xs md:max-w-sm"
              shape="round"
              [disabled]="showUrlError"
            >
              @if (showFirmaDigitalHome) {
                <span class="text-base md:text-lg">Comenzar</span>
              } @else {
                <span class="text-base md:text-lg">¡Me interesa!</span>
              }
            </ion-button>
          </section>
        </ion-row>

        <!-- Footer -->
        <ion-row class="w-full flex justify-center pb-4 md:pb-6">
          <section class="flex flex-row justify-center items-center gap-2">
            <ion-text>
              <span class="text-sm md:text-base">Powered by</span>
            </ion-text>
            <ion-img
              class="w-8 h-8 md:w-10 md:h-10"
              src="../../../assets/obd-logo.svg"
            >
            </ion-img>
            <ion-text class="font-bold text-sm md:text-base">
              <span>Onboarding Digital</span>
            </ion-text>
          </section>
        </ion-row>
      </div>
    }
  </ion-grid>
</div>
